import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { compose } from 'redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import style from './SchoolInfo.scss';
import SubwayIcon from '../icons/Subway';
import SchoolPin from './SchoolPin';

const messages = defineMessages({
  directions: {
    id: 'map.popup.directions',
    defaultMessage: 'Directions',
    description: 'Pop up directions label',
  },
  programs: {
    id: 'map.popup.programs',
    defaultMessage: 'Favorited Programs',
    description: 'Pop up programs label',
  },
  distance: {
    id: 'map.popup.distance',
    defaultMessage: '{distance} from home',
    values: {
      distance: 'x',
    },
    description: 'distance from home',
  },
  getDirections:{
    id: 'map.popup.getdirectionslabel',
    defaultMessage: 'Get directions',
    description: 'Get directions label',
  }
});

class SchoolInfo extends PureComponent {
  static propTypes = {
    onSchoolTitleClick: PropTypes.func,
    onSchoolProgramClick: PropTypes.func,
    info: PropTypes.arrayOf(
      PropTypes.shape({
        accessibility: PropTypes.string,
        // distance: PropTypes.string,
        gradesDescription: PropTypes.string,
        // id: PropTypes.number,
        // name: PropTypes.string,
        // programs: PropTypes.string,
        // schoolAddress: PropTypes.string,

        directions: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.shape())]),
        distance: PropTypes.string,
        // this bothers me ... why number OR string?
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        // label: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        name: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        programs: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.shape())]),
        schoolAddress: PropTypes.string.isRequired,
        dbn: PropTypes.string,
      }),
    ).isRequired,
    homeAddress: PropTypes.string,
  };

  static defaultProps = {
    onSchoolTitleClick: null,
    onSchoolProgramClick: null,
    homeAddress: null,
  };

  handleSchoolTitleClick = ({ id, dbn }) => {
    const { onSchoolTitleClick } = this.props;
    if (onSchoolTitleClick) {
      onSchoolTitleClick(Number(id), dbn);
    }
  };

  handleSchoolProgramClick = ({ id, schoolId, dbn }) => {
    const { onSchoolProgramClick } = this.props;

    if (onSchoolProgramClick) {
      onSchoolProgramClick(id, schoolId, dbn);
    }
  };

  render() {
    // const { info } = this.props;
    const { homeAddress, info } = this.props;
    const { distance, schoolAddress } = info[0];

    let directionsLink = '';
    const homeAddressURI = encodeURI(homeAddress);
    const schoolAddressURI = encodeURI(schoolAddress);
    if (homeAddress) {
      directionsLink = (
        <a
          rel="noopener"
          target="_blank"
          href={`https://www.google.com/maps/dir/${homeAddressURI}/${schoolAddressURI}`}
        >
          <span><FormattedMessage {...messages.getDirections} /></span>
        </a>
      );
    }
    return (
      <div className={style.schoolInfo}>
        <div className={style.content}>
          {info.map(school => (
            <div key={school.id}>
              <div
                //
                tabIndex="0"
                onClick={() => this.handleSchoolTitleClick({ id: school.id, dbn: school.dbn })}
                onKeyDown={() => this.handleSchoolTitleClick({ id: school.id, dbn: school.dbn })}
                role="button"
                className={style.schoolNameButton}
              >
                <div className={style.container}>
                  <div className={style.icon}>
                    <SchoolPin width={30} height={30} type={school.icon} onClick={() => this.handleSchoolTitleClick({ id: school.id, dbn: school.dbn })} />
                  </div>
                  <div className={style.detail}>
                    {school.name}
                  </div>
                </div>
              </div>
              {school.programs.length > 0 && (
                <>
                  <div className={style.programsLabel}>
                    <FormattedMessage {...messages.programs} />
                  </div>
                  <ul className={style.programs}>
                    {school.programs.map(program => (
                      <li
                        //
                        key={program.name}
                        className={style.program}
                      >
                        <span
                          role="button"
                          tabIndex="0"
                          onClick={() => this.handleSchoolProgramClick({ id: Number(program.id), schoolId: school.id, dbn: school.dbn })}
                          onKeyDown={() =>
                            this.handleSchoolProgramClick({ id: Number(program.id), schoolId: school.id, dbn: school.dbn })
                          }
                        >
                          {program.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          ))}
          {distance && (
            <div className={style.distance}>
              <SubwayIcon size={18} />
              <FormattedMessage
                {...messages.distance}
                values={{
                  distance,
                }}
              />
            </div>
          )}
        </div>
        {homeAddress && <div className={style.directions}>{directionsLink}</div>}
      </div>
    );
  }
}

export default compose(
  //
  // injectIntl,
  // withRtl(style),
  withStyles(style),
)(SchoolInfo);
